import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Temporary kill-switch: hides all customer-facing Judge.me review UI
// (reviews section + star badges) while imported reviews are corrected.
// Set back to true to re-enable — integration and data stay fully intact.
export const JUDGEME_REVIEWS_VISIBLE = true;

let promise = null;

// Single shared request for all Judge.me consumers (badge + reviews section).
export const getJudgeMeData = () => {
  if (!promise) {
    promise = axios
      .get(`${API}/judgeme/widgets`)
      .then((res) => res.data)
      .catch(() => null);
  }
  return promise;
};

export const widgetReviewCount = (html) => {
  const match = /data-number-of-reviews='(\d+)'/.exec(html || "");
  return match ? parseInt(match[1], 10) : 0;
};
